import { Trans } from 'react-i18next';
import { BulletListValueProps } from 'spindl-shared-components';

import i18n from '../modules/locale/i18n';
import EmailTooltip, { EmailTooltipValueProps, EmailTooltipProps } from '../components/atoms/EmailTooltip';

export const getTranslation = (transKey: string, values?: Record<string, unknown>): React.ReactNode => {
  return (
    <Trans
      i18n={i18n}
      i18nKey={transKey}
      values={values}
      components={{
        bold: <strong />,
      }}
    />
  );
};

export const emailTemplateTooltipContent = (errors?: React.ReactNode[]): JSX.Element => {
  const t = i18n.t;
  let emailTooltipProps: EmailTooltipValueProps & EmailTooltipProps;

  if (errors?.length) {
    const bulletListProps: BulletListValueProps = {
      texts: errors.map((error) => ({ value: error })),
    };
    emailTooltipProps = {
      state: 'Incomplete',
      text: {
        value: getTranslation('email_templates.icon_tooltip.incomplete'),
      },
      bulletList: bulletListProps,
    };
  } else {
    emailTooltipProps = {
      state: 'Complete',
      text: {
        value: t('email_templates.icon_tooltip.complete'),
      },
    };
  }

  return <EmailTooltip {...emailTooltipProps} />;
};
  